
const TikTokIcon = ({ className = "" }: { className?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M19.321 5.562a5.124 5.124 0 0 1-.443-.467 5.992 5.992 0 0 1-1.343-3.168c-.037-.284-.05-.57-.059-.856H13.99v11.866c0 .108-.004.215-.012.321a3.005 3.005 0 0 1-1.562 2.297 2.98 2.98 0 0 1-1.553.435 2.995 2.995 0 0 1-2.701-1.699 2.994 2.994 0 0 1 1.758-4.222 2.995 2.995 0 0 1 1.644-.154l.002-3.494a6.492 6.492 0 0 0-2.904.57 6.477 6.477 0 0 0-2.345 1.72 6.494 6.494 0 0 0-1.357 2.454 6.496 6.496 0 0 0 1.45 6.462 6.478 6.478 0 0 0 2.308 1.667 6.491 6.491 0 0 0 7.034-.58 6.476 6.476 0 0 0 2.252-2.73 6.49 6.49 0 0 0 .574-2.73V8.945c1.188.781 2.552 1.197 3.947 1.195V6.654a4.41 4.41 0 0 1-3.205-1.092z" />
    </svg>
  );
};

export default TikTokIcon;
